/*=========================================================================================
  File Name: moduleChat.js
  Description: Chat Module
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import state from "./moduleUserState.js";
import mutations from "./moduleUserMutations.js";
// import actions from "./modulePostActions.js";
// import getters from "./modulePostGetters.js";

export default {
  namespaced: true,
  state: state,
  mutations: mutations,
//   actions: actions,
//   getters: getters
};
